import * as Types from '../../../types/bff/gql-schema';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const AvailableBookingTimeSlotsDocument = `
    query AvailableBookingTimeSlots {
  availableBookingTimeSlots {
    targetDate
    status
    displayName
    schedules {
      remainingCount
      bookingStatus
      startTimeSlot {
        displayTime
        value
        fromDisplayTime
        toDisplayTime
      }
      endTimeSlot {
        displayTime
        value
        fromDisplayTime
        toDisplayTime
      }
    }
  }
}
    `;
export const useAvailableBookingTimeSlotsQuery = <
      TData = Types.AvailableBookingTimeSlotsQuery,
      TError = Types.GraphqlError
    >(
      variables?: Types.AvailableBookingTimeSlotsQueryVariables,
      options?: UseQueryOptions<Types.AvailableBookingTimeSlotsQuery, TError, TData>,
    ) =>
    useQuery<Types.AvailableBookingTimeSlotsQuery, TError, TData>(
      variables === undefined ? ['AvailableBookingTimeSlots'] : ['AvailableBookingTimeSlots', variables],
      gqlFetcher<Types.AvailableBookingTimeSlotsQuery, Types.AvailableBookingTimeSlotsQueryVariables>(AvailableBookingTimeSlotsDocument, 'AvailableBookingTimeSlots', variables),
      options
    );

useAvailableBookingTimeSlotsQuery.getKey = (variables?: Types.AvailableBookingTimeSlotsQueryVariables) => variables === undefined ? ['AvailableBookingTimeSlots'] : ['AvailableBookingTimeSlots', variables];
;

useAvailableBookingTimeSlotsQuery.fetcher = (variables?: Types.AvailableBookingTimeSlotsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.AvailableBookingTimeSlotsQuery, Types.AvailableBookingTimeSlotsQueryVariables>(AvailableBookingTimeSlotsDocument, 'AvailableBookingTimeSlots', variables, options);